import LoadingSpinner from './LoadingSpinner';
import enhance from './LoadingSpinner.enhancer';

export default enhance(LoadingSpinner);
